import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { ISignInMagicLinkXP } from "@faire/web-api--source/indigofair/seo/ISignInMagicLinkXP";
import { ENABLE_MFA_TIMING_XP_241018 } from "@faire/web-api--source/indigofair/settings/ENABLE_MFA_TIMING_XP_241018";
import { ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_PROMINENCE_TEST_103024 } from "@faire/web-api--source/indigofair/settings/ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_PROMINENCE_TEST_103024";
import { ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_TEST_092024 } from "@faire/web-api--source/indigofair/settings/ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_TEST_092024";
import { ENABLE_SIGN_IN_IMPROVEMENTS_MFA_EXPERIENCE_TEST_092024 } from "@faire/web-api--source/indigofair/settings/ENABLE_SIGN_IN_IMPROVEMENTS_MFA_EXPERIENCE_TEST_092024";
import { ENABLE_MFA_WITH_CORRECT_CODE_INCORRECT_PASSWORD_250211 } from "@faire/web-api--source/indigofair/settings/ENABLE_MFA_WITH_CORRECT_CODE_INCORRECT_PASSWORD_250211";
export var useSettingMfaTimingXP = function() {
    return useSetting(ENABLE_MFA_TIMING_XP_241018, false);
};
export var useAssignSettingSignInMagicLinkImprovements = function() {
    return useAssignSetting(ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_TEST_092024);
};
var useSettingMagicLinkSignInImprovements = function() {
    return useSetting(ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_TEST_092024, ISignInMagicLinkXP.Bucket.CONTROL);
};
export var useSettingMagicLinkProminenceXP = function() {
    return useSetting(ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_PROMINENCE_TEST_103024, ISignInMagicLinkXP.Bucket.CONTROL);
};
export var useAssignSettingMagicLinkProminenceXP = function() {
    return useAssignSetting(ENABLE_SIGN_IN_IMPROVEMENTS_MAGIC_LINK_PROMINENCE_TEST_103024);
};
export var useSettingMFAExperienceXP = function() {
    return useSetting(ENABLE_SIGN_IN_IMPROVEMENTS_MFA_EXPERIENCE_TEST_092024, false);
};
export var useIsNewMagicLinkExperience = function(variant) {
    var isMagicLink = useSettingMagicLinkSignInImprovements();
    if (variant) {
        return isMagicLink === variant;
    }
    return isMagicLink !== ISignInMagicLinkXP.Bucket.CONTROL;
};
export var useSettingAllowMFASkipPassword = function() {
    return useSetting(ENABLE_MFA_WITH_CORRECT_CODE_INCORRECT_PASSWORD_250211, false);
};
